<template>
  <div>
    <section
      class="con-wrapper botAppTabs"
      v-loading="loading"
      :myProjectsSearchId="myProjectsSearchId"
      v-if="dataLoaded"
    >
      <!-- {{this.$route.query.title}} -->
      <!--
        draft, 草稿
    pendingReview, 等候審查
    inReview, 審查中
    reviewed, 等候發佈
    waitingDeveloperPublish, 等候開發者發佈
    published, 販售中
    preOrder, 預購販售中
    removed, 已移除
    rejected, 已拒絕
    unpublished, 開發者移除
    developerRejected, 開發者拒絕
      -->
      <!-- <h1>user</h1>
      <button @click="getCurState">get State</button>-->
      <!-- <button @click="changeStatus('developerRejected')">手動取消審查 / 開發者拒絕</button> -->
      <!-- POST /developer/reject/app/:appId -->
      <!-- <button @click="changeStatus('published')">手動上架 / 販售中</button> -->
      <!-- post  /developer/publish/app/:appId-->
      <!-- <button @click="changeStatus('unpublished')">手動下架 / 移除</button> -->
      <!--下架 post  /developer/unpublish/app/:appId-->
      <!-- <hr>
      <h1>nuwa</h1>-->
      <!-- <button @click="changeStatus('waitingDeveloperPublish')">等候開發者發佈</button>
      <button @click="changeStatus('inReview')">女媧審查中(move to reviewing)</button>
      <button @click="changeStatus('rejected')">女媧拒絕(move to rejected)</button>
      <button @click="changeStatus('reviewed')">等候發佈(move to rejected)</button>

      <button @click="changeStatus('published')">女媧上架(move to pub)</button>
      <button @click="changeStatus('removed')">女媧下架 / 移除(move to unpublish)</button>-->
      <!-- <el-select
        v-model="appInfo.status"
        @change="statusSelectorChanged"
        placeholder="Select"
        size="mini"
      >
        <el-option
          v-for="item in AllOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >{{`${item.label}-${item.value}`}}</el-option>
      </el-select>-->
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="12"></el-col>
        <el-col :span="12">
          <div class="op-buttons">
            <el-select
              v-model="appInfo.lastStatus"
              placeholder="Select"
              size="mini"
              v-if="applyStatus.storeCtrl.show"
              :disabled="!(applyStatus.storeCtrl.enable)"
              @change="pubChanged"
            >
              <el-option
                v-for="item in pubOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>&nbsp;&nbsp;
            <el-button
              @click="enableNewAPK()"
              :type="(applyStatus.button.newAPK.enable)?'primary':'info'"
              v-if="applyStatus.button.newAPK.show"
              :disabled="!(applyStatus.button.newAPK.enable)"
            >{{t_content(applyStatus.button.newAPK.label)}}</el-button>
            <!-- commonAction('newAPK') -->
            <el-button
              @click="commonAction('discardAPK')"
              :type="(applyStatus.button.discardAPK.enable)?'primary':'info'"
              v-if="applyStatus.button.discardAPK.show"
              :disabled="!(applyStatus.button.discardAPK.enable)"
            >{{t_content(applyStatus.button.discardAPK.label)}}</el-button>
          </div>
        </el-col>
      </el-row>

      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="18">
          <h1>{{projectName}}</h1>&nbsp;&nbsp;&nbsp;
          <h3>{{t_content('botApp.common.version')}} {{packageVersion}}</h3>
          <!-- <div v-if="isUpdate">editing</div> -->
          &nbsp;&nbsp;
          <el-tooltip class="item" effect="light" placement="top">
            <template slot="content">
                <span v-html="t_content(`botApp.common.status.${appInfo.status}.tooltip`)"></span>
            </template>
            <el-tag :type="statusType[appInfo.status]">{{t_content(`botApp.common.status.${appInfo.status}`)}}</el-tag>
          </el-tooltip>
        </el-col>
        <el-col :span="6">
          <div class="op-buttons">
            <el-button
              v-if="(applyStatus.button.save.show)"
              :type="(applyStatus.button.save.enable)?'primary':'info'"
              size="medium"
              @click="saveForm('form')"
              :disabled="!(applyStatus.button.save.enable)"
            >{{t_content(applyStatus.button.save.label)}}</el-button>
            <el-button
              v-if="(applyStatus.button.submit.show)"
              :type="(applyStatus.button.submit.enable)?'primary':'info'"
              size="medium"
              @click="submitForm('form')"
              :disabled="!(applyStatus.button.submit.enable)"
            >{{t_content('botApp.common.submit')}}</el-button>
            <el-button
              v-if="(applyStatus.button.devReject.show)"
              :type="(applyStatus.button.devReject.enable)?'primary':'info'"
              size="medium"
              @click="commonAction('devReject')"
            >{{t_content(applyStatus.button.devReject.label)}}</el-button>
            <!-- {{t_content('botApp.common.cancelReview')}} -->
            <el-button
              v-if="(applyStatus.button.publish.show)"
              :type="(applyStatus.button.publish.enable)?'primary':'info'"
              size="medium"
              @click="commonAction('publish')"
            >{{t_content(applyStatus.button.publish.label)}}</el-button>
            <!-- {{t_content('botApp.common.cancelReview')}} -->
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-alert
          :title="t_content('botApp.common.submit.alert.title')"
          type="warning"
          v-if="(errMsgs().length > 0)"
          show-icon
        >
          <ul>
            <li v-for="(msg, index) in errMsgs()" :key="index">{{msg}}</li>
          </ul>
        </el-alert>
        <el-col :span="24">
          <el-tabs type="border-card" v-model="activeTabsValue">
            <el-tab-pane name="basicInformation">
              <span slot="label" :class="validClass(0).className">
                {{t_content('botApp.tabLabel.basicInformation')}} &nbsp;
                <font-awesome-icon :icon="validClass(0).iconName" class="icon"/>
                <!-- check -->
              </span>
              <tab-01 :appInfo="appInfo" :applyStatus="applyStatus" ref="tab01"/>
            </el-tab-pane>
            <el-tab-pane label="Config" name="marketStoreInfo">
              <span slot="label" :class="validClass(1).className">
                {{t_content('botApp.tabLabel.marketStoreInfo')}} &nbsp;
                <font-awesome-icon :icon="validClass(1).iconName" class="icon"/>
              </span>
              <tab-02
                :appInfo="appInfo"
                :applyStatus="applyStatus"
                :hideDate="hideDate()"
                ref="tab02"
              />
            </el-tab-pane>
            <el-tab-pane label="Role" name="price">
              <span slot="label" :class="validClass(2).className">
                {{t_content('botApp.tabLabel.price')}} &nbsp;
                <font-awesome-icon :icon="validClass(2).iconName" class="icon"/>
              </span>
              <tab-03 :appInfo="appInfo" :applyStatus="applyStatus" ref="tab03"/>
            </el-tab-pane>
            <el-tab-pane label="Task" name="contentrating">
              <span slot="label" :class="validClass(3).className">
                <span
                  v-tooltip.top.notrigger="{
                    //content:'tooltipContent',
                    html: 'tooltipContent',
                    visible: tab04Tooltip,
                    class: 'tooltip-custom tooltip-other-custom'
                }"
                >
                  <span>
                    {{t_content('botApp.tabLabel.contentrating')}} &nbsp;
                    <font-awesome-icon :icon="validClass(3).iconName" class="icon"/>
                  </span>
                </span>
                <!-- exclamation-->
              </span>
              <tab-04 :appInfo="appInfo" :applyStatus="applyStatus" ref="tab04"/>
            </el-tab-pane>

            <div id="tooltipContent">
              <span v-html="t_content(applyStatus.page.tab04.tooltip.msg)"></span>
            </div>

            <el-tab-pane label="Task" name="APKUpload">
              <span slot="label" :class="validClass(4).className">
                {{t_content('botApp.tabLabel.APKUpload')}} &nbsp;
                <font-awesome-icon :icon="validClass(4).iconName" class="icon"/>
              </span>
              <tab-05 :appInfo="appInfo" :applyStatus="applyStatus" ref="tab05" :key="apkFileKey"/>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </section>
  </div>
</template>

<script>
import Tab01 from './tab01.vue'
import Tab02 from './tab02.vue'
import Tab03 from './tab03.vue'
import Tab04 from './tab04.vue'
import Tab05 from './tab05.vue'
import '../botApp.scss'
import api from '../../../api'
import apiConfig from '../../../api/apiConfig'
import _ from 'lodash'
import BotAppStatusMapper from '../botAppStatusMapper'
import StatusType from '../botAppStatusMapper/statusTagType'
import { mappingArray } from '../botAppCommon'

export default {
    beforeRouteLeave (to, from, next) {
        let { enable } = this.applyStatus.leaveAlert
        if (enable && this.isAppInfoChanged()) {
            let { title, msg, ok, cancel } = this.applyStatus.leaveAlert.dialog
            this.$confirm(this.t_content(msg), this.t_content(title), {
                confirmButtonText: this.t_content(ok),
                cancelButtonText: this.t_content(cancel),
                type: 'warning'
            })
                .then(() => {
                    next()
                })
                .catch(() => {
                    next(false)
                    this.$store.state.isFlagLiClass = 'MyProjectsEdit'
                    this.$store.state.isFlagSpanClass = 'MyProjectsList'
                })
        } else {
            next()
        }
    },
    mounted () {
        let vm = this
        console.log(vm.$store)
        if (!vm.$route.params.appId) {
            let appId = localStorage.getItem('appId')
            vm.$router.push({
                name: 'MyProjectsEdit',
                params: { appId: appId }
            })
        } else {
            localStorage.setItem('appId', vm.$route.params.appId)
        }
        vm.$root.$on('langChanged', langCode => {
            vm.showStatus()
        })
        let secondNavItem = [
            { path: 'MyProjectsEdit', msg: 'header.secondFloor.route.name.process' },
            true,
            { path: 'MyProjectsVersion', msg: 'header.secondFloor.route.name.versionHst' }
        ]
        vm.$store.state.secondNavItem = secondNavItem

        if (vm.$route.name === 'MyProjectsAdd') {
            vm.showStatus()
            vm.dataLoaded = true
        } else {
            vm.getAppInfo()
        }
        vm.clearMsgs()
    },
    data () {
        return {
            apkFileKey: '0000001',
            statusPhase: '',
            appType: '',
            discardAPK: false,
            activeTabsValue: 'basicInformation',
            tab04Tooltip: true,
            pubOptions: [
                {
                    value: 'published',
                    label: '販售中'
                },
                {
                    value: 'unpublished',
                    label: '取消販售'
                }
            ],
            AllOptions: [
                { value: 'draft', label: '草稿' },
                { value: 'pendingReview', label: '等候审查' },
                { value: 'inReview', label: '审查中' },
                { value: 'reviewed', label: '等候发布' },
                { value: 'waitingDeveloperPublish', label: '等候开发者发布' },
                { value: 'published', label: '贩售中' },
                { value: 'preOrder', label: '预购贩售中' },
                { value: 'removed', label: '已移除' },
                { value: 'rejected', label: '已拒绝' },
                { value: 'unpublished', label: '开发者移除' },
                { value: 'developerRejected', label: '开发者拒绝' }
            ],
            statusType: StatusType,
            statusText: '',
            appInfo: {
                package: null,
                publishSecret: null,
                // appId: '',
                contentType: '',
                // prices: [],
                prices: [
                    // required
                    //     // {
                    //     //     currency: '',
                    //     //     price: 0,
                    //     //     miboStoreMarketId: 0,
                    //     //     miboStoreLangId: 0,
                    //     //     miboStoreCurrencyId: 0
                    //     // }
                ],

                contentExtra: null,
                apkFile: null,
                previewApkFile: null,
                // {
                //     size: '',//required
                //     versionCode: 0,
                //     versionName: '',
                //     previewSize: '',
                //     previewVersionCode: 0,
                //     previewVersionName: ''
                // },
                // miboStoreCategoryId: 0,
                // miboStoreAgeId: 0,
                // miboStoreGoodsProductId: 0,
                tagIds: [],
                marketIds: [],
                status: 'draft',
                isFree: 'Y',
                publishType: 'auto',
                publishBeginDate: null, // required
                // publishEndDate: '', // required
                candidate: [
                    // {
                    //     title: '',
                    //     desc: '',
                    //     tag: '',
                    //     slogan: '',
                    //     langCode: '',
                    //     function: [],
                    //     keyword: [],
                    //     icons: [],
                    //     screenshot: [],
                    //     promotion: '',
                    //     videoUrl: '',
                    //     isDefault: ''
                    // }
                ],
                invocations: [],
                supportLangs: [],
                ratings: [
                    // {
                    //     id: 0,
                    //     answer: ''
                    // }
                ],
                downloadUrl: '',
                previewDownloadUrl: '',
                isDefaultCustomerServiceSetting: 'N',
                customerServiceMail: '',
                customerServicePhone: '',
                customerServiceWeb: '',
                customerServicePrivacyUrl: '',
                releaseNote: '',
                testInstruction: '',
                metadata: '',
                oriDownloadUrl: '',
                age: '',
                // mainMarket: 0,
                isAcceptExportLaw: 'N',
                // zevi fake
                lastVersionCode: null,
                lastStatus: '',
                isUploadApk: null
            },
            // tabsValid: [true, true, false, null, null],
            tabsValid: [null, null, null, null, null],
            dataLoaded: false,
            loading: false,
            appStatus: [
                'draft',
                'pendingReview',
                'inReview',
                'reviewed',
                'waitingDeveloperPublish',
                'published',
                'preOrder',
                'removed',
                'rejected',
                'unpublished',
                'developerRejected'
            ],
            // appLockStatus: ['pendingReview', 'inReview'],
            applyStatus: {},
            curLastStatus: ''
        }
    },
    components: {
        'tab-01': Tab01,
        'tab-02': Tab02,
        'tab-03': Tab03,
        'tab-04': Tab04,
        'tab-05': Tab05
    },
    methods: {
        t_content (tKey) {
            return this.$t(tKey, {
                contentType: this.$t(`botApp.${this.$store.state.contentType}`)
            })
        },
        hideDate () {
            return this.statusPhase === 'p2'
        },
        enableNewAPK () {
            let callback = () => {
                // active page.
                this.activeTabsValue = 'APKUpload'
                this.applyStatus.page.tab05.enable = true
                this.applyStatus.button.save.show = true
            }
            this.commonAction('newAPK', callback)
        },
        pubChanged (value) {
            let actionName = value.substring(0, value.length - 2)
            let {
                title,
                msg,
                ok,
                cancel,
                method,
                apiUrl,
                withBody
            } = this.applyStatus.button[actionName].dialog
            title = String.format(
                this.t_content(title),
                this.appInfo.contentExtra.versionName
            )
            msg = String.format(this.t_content(msg), this.appInfo.contentExtra.versionName)
            this.$confirm(msg, title, {
                confirmButtonText: this.t_content(ok),
                cancelButtonText: this.t_content(cancel),
                type: 'warning'
            })
                .then(() => {
                    this.doSubmitForm({ method, apiUrl, withBody }, actionName)
                    this.curLastStatus = value
                })
                .catch(() => {
                    this.appInfo.lastStatus = this.curLastStatus
                })
        },
        statusSelectorChanged (v) {
            alert(v)
            this.getCurState(v)
        },
        getCurState (newState) {
            let {
                lastVersionCode = null, // online version
                lastStatus = null, // online status
                status = null, // draft vsersion
                isUploadApk = null,
                publishType = null
            } = this.appInfo

            let versionCode = null
            if (this.appInfo.contentExtra) {
                versionCode = this.appInfo.contentExtra.versionCode
            }

            let appStatusInfo = {
                lastVersionCode,
                lastStatus,
                versionCode,
                status,
                isUploadApk,
                publishType
            }
            if (newState) {
                appStatusInfo.status = newState
            }
            console.log('applyStatus', this.applyStatus)
            let retVal = BotAppStatusMapper(appStatusInfo)
            this.applyStatus = retVal[0]
            this.statusPhase = retVal[1]
        },
        changeStatus (status) {
            alert(status)
        },

        getTab01Data () {
            this.appInfo = {
                ...this.appInfo,
                ...this.$refs.tab01.getDataFromChild()
            }
        },
        getTab02Data () {
            this.appInfo = {
                ...this.appInfo,
                ...this.$refs.tab02.getDataFromChild()
            }
        },
        getTab03Data () {
            this.appInfo = {
                ...this.appInfo,
                ...this.$refs.tab03.getDataFromChild()
            }
        },
        getTab04Data () {
            this.appInfo = {
                ...this.appInfo,
                ...this.$refs.tab04.getDataFromChild()
            }
        },
        getTab05Data () {
            this.appInfo = {
                ...this.appInfo,
                ...this.$refs.tab05.getDataFromChild()
            }
        },
        purifyPostData (appInfo) {
            delete appInfo.apkFile
            delete appInfo.previewApkFile
            if (appInfo.contentExtra == null) {
                delete appInfo.contentExtra
            }
            if (appInfo.contentType == null) {
                delete appInfo.contentType
            }
            if (appInfo.publishBeginDate == null) {
                delete appInfo.publishBeginDate
            }
            if (appInfo.isFree === 'Y') {
                appInfo.prices = []
            }
            if (appInfo.publishBeginDate === '') {
                delete appInfo.publishBeginDate
            }
            if (appInfo.contentExtra === null) {
                delete appInfo.contentExtra
            }
            if (this.discardAPK) {
                appInfo.downloadUrl = ''
                this.discardAPK = false
            }
            delete appInfo.lastStatus

            delete appInfo.lastVersionCode
            delete appInfo.isUploadApk
        },
        validClass (tabIdx) {
            let classValid = {
                className: '',
                iconName: 'check'
            }
            switch (this.tabsValid[tabIdx]) {
                case true:
                    classValid.className = 'valid'
                    classValid.iconName = 'check'
                    break
                case false:
                    classValid.className = 'invalid'
                    classValid.iconName = 'exclamation'
                    break
                default:
                    break
            }

            if (tabIdx === 3 && this.applyStatus.page.tab04.tooltip.on) {
                classValid.className = 'invalid'
                classValid.iconName = 'exclamation'
            }

            return classValid
        },
        async getAppType () {
            let vm = this
            const apiUri = `developer/app/${vm.$route.params.appId}`
            const apiCfg = apiConfig(apiUri)

            let appData
            let appType = 'application'
            try {
                let response = await api.request(
                    'get',
                    apiCfg.path,
                    null,
                    null,
                    apiCfg.headers
                )
                appData = response.data.data.payload
                if (appData.length > 0) {
                    appType = appData[0].contentType
                    this.$store.state.contentType = appType
                }
            } catch (error) {
                console.log(error)
            }

            return appType
        },
        async getAppInfo () {
            let vm = this
            vm.loading = true
            // const { title, message, status, publishAfterDate } = this
            const apiUri = `developer/deploy/app/${vm.$route.params.appId}`
            const apiCfg = apiConfig(apiUri)
            // let body = { ...vm.form }

            vm.appType = await vm.getAppType()

            api
                .request('get', apiCfg.path, null, null, apiCfg.headers)
                .then(response => {
                    const appInfoData = response.data.data.payload
                    vm.copyObject(vm.appInfo, { ...appInfoData[0] })

                    // zevi fake data. p3
                    // vm.appInfo.contentExtra.versionCode = 2
                    // vm.appInfo.status = 'draft'
                    // vm.appInfo.lastVersionCode = 1
                    // vm.appInfo.lastStatus = 'published'
                    // vm.appInfo.isUploadApk = true

                    // zevi fake data. p2
                    // vm.appInfo.contentExtra.versionCode = 1
                    // vm.appInfo.status = 'published'
                    // vm.appInfo.status = 'pendingReview'
                    // vm.appInfo.status = 'inReview'
                    // vm.appInfo.lastStatus = 'published'

                    if (vm.appInfo.lastStatus === 'reviewed' && vm.appInfo.status === 'published') {
                        vm.appInfo.lastStatus = 'published'
                    }

                    if (!vm.appInfo.lastStatus) {
                        vm.appInfo.lastStatus = vm.appInfo.status
                    }
                    vm.showStatus()
                    vm.getCurState()
                    vm.curLastStatus = vm.appInfo.lastStatus
                    vm.tab04Tooltip = vm.applyStatus.page.tab04.tooltip.on
                    vm.keepoOrgAppInfo()
                    vm.appInfo.contentType = vm.appType
                    if (vm.appInfo.publishType === 'candidate' &&
                        vm.appInfo.status === 'reviewed') {
                        vm.applyStatus.button.save.show = false
                        vm.applyStatus.button.publish.show = true
                    }
                    // notify tab5 update
                    vm.apkFileKey = Math.random().toString(36).substring(7)

                    vm.dataLoaded = true
                    vm.loading = false
                })
                .catch(error => {
                    console.log(error)
                })
        },
        keepoOrgAppInfo () {
            this.$store.state.originalAppInfo = { ...this.appInfo }
        },

        // obj2 copy to obj1
        copyObject (obj1, obj2) {
            Object.keys(obj2).forEach(function (key) {
                if (key in obj1) {
                    obj1[key] = obj2[key]
                }
            })
        },
        async validAllTabs () {
            const tabsVal = [
                this.validTab01(),
                this.validTab02(),
                this.validTab03(),
                this.validTab04(),
                this.validTab05()
            ]
            const vret = await Promise.all(tabsVal)
            this.tabsValid = vret
            return this.testValid(vret)
        },

        async validTab01 () {
            return new Promise(
                this.$refs.tab01.$refs['form'].validate,
                (valid, errObject) => {
                    return valid
                }
            )
        },
        async validTab02 () {
            return new Promise(
                this.$refs.tab02.$refs['form'].validate,
                (valid, errObject) => {
                    return valid
                }
            )
        },
        async validTab03 () {
            const marketsVal = _.map(this.$refs.tab03.$refs['market'], o => {
                return new Promise(o.$refs['form'].validate, (valid, errObject) => {
                    return valid
                })
            })
            return Promise.all(marketsVal).then(r => this.testValid(r))
        },
        async validTab04 () {
            return new Promise(
                this.$refs.tab04.$refs['form'].validate,
                (valid, errObject) => {
                    return valid
                }
            )
        },
        async validTab05 () {
            return new Promise(
                this.$refs.tab05.$refs['form'].validate,
                (valid, errObject) => {
                    return valid
                }
            )
        },
        clearMsgs () {
            this.$store.state.botAppErrMessages = []
            let alertBox = document.querySelector('.el-alert.el-alert--warning')
            alertBox && (alertBox.style.display = '-webkit-box')
        },
        async submitForm () {
            this.clearMsgs()

            var vResult = await this.validAllTabs()
            try {
                if (vResult) {
                    let {
                        title,
                        msg,
                        ok,
                        cancel,
                        method,
                        apiUrl,
                        withBody
                    } = this.applyStatus.button.submit.dialog
                    this.$confirm(this.t_content(msg), this.t_content(title), {
                        confirmButtonText: this.t_content(ok),
                        cancelButtonText: this.t_content(cancel),
                        type: 'warning'
                    }).then(() => {
                        this.doSubmitForm({ method, apiUrl, withBody }, 'submit')
                    })
                } else {
                    let errMsg = this.t_content('botApp.common.valid.dataCheck')
                    this.$alert(errMsg, 'Error', {
                        type: 'error',
                        confirmButtonText: this.t_content('botApp.common.valid.ok')
                    })
                    return false
                }
            } catch (e) {
                console.log(e)
            }
        },
        doSubmitForm (actOpt, btnName) {
            const apiUri = String.format(actOpt.apiUrl, this.$route.params.appId)
            let rspOpt = {
                apiUri,
                action: actOpt.method,
                withBody: actOpt.withBody
            }

            let opt = this.applyStatus.button[btnName].rep_dialog
            opt = { ...opt, ...rspOpt }
            this.submitHelper(opt)
        },
        async saveForm () {
            this.clearMsgs()
            await this.validAllTabs()
            let { method, apiUrl, withBody } = this.applyStatus.button.save.dialog
            try {
                this.doSubmitForm({ method, apiUrl, withBody }, 'save')
            } catch (e) {
                console.log(e)
            }
        },
        commonAction (actionName, callback) {
            let vm = this
            // devReject
            let {
                title,
                msg,
                ok,
                cancel,
                method,
                apiUrl,
                withBody
            } = vm.applyStatus.button[actionName].dialog
            title = String.format(
                this.t_content(title),
                vm.appInfo.contentExtra.versionName
            )
            msg = String.format(this.t_content(msg), vm.appInfo.contentExtra.versionName)
            vm.$confirm(msg, title, {
                confirmButtonText: this.t_content(ok),
                cancelButtonText: this.t_content(cancel),
                type: 'warning'
            }).then(() => {
                if (callback) {
                    callback()
                } else {
                    if (actionName === 'discardAPK') {
                        // discard apk set contentExtra == null
                        this.discardAPK = true
                    }
                    vm.doSubmitForm({ method, apiUrl, withBody }, actionName)
                }
            })
        },
        getAllData () {
            this.getTab01Data()
            this.getTab02Data()
            this.getTab03Data()
            this.getTab04Data()
            this.getTab05Data()
            return this.appInfo
        },
        submitHelper (options) {
            const { apiUri, action, title, msg } = options
            this.loading = true
            const apiCfg = apiConfig(apiUri)
            let body = null

            if (options.withBody) {
                body = { ...this.getAllData() }
                this.purifyPostData(body)
            }

            api
                .request(action, apiCfg.path, body, null, apiCfg.headers)
                .then(response => {
                    this.loading = false
                    this.$alert(this.t_content(msg), this.t_content(title), {
                        confirmButtonText: 'OK',
                        callback: action => {
                            this.getAppInfo() // Zevi
                        }
                    })
                })
                .catch(err => {
                    this.loading = false
                    let errMsg
                    if (err.response && err.response.status !== 200) {
                        errMsg = err.response.data.status.description
                    }
                    this.$alert(errMsg, 'Error', {
                        type: 'error',
                        confirmButtonText: 'OK'
                    })
                })
        },
        async _transferStatusAsync (status, langCode) {
            let findResult = _.find(mappingArray, { db: status })
            if (findResult) {
                if (
                    langCode &&
          findResult.displayI18n &&
          findResult.displayI18n[langCode]
                ) {
                    return Promise.resolve(findResult.displayI18n[langCode])
                }
                return Promise.resolve(findResult.display)
            }
            return Promise.resolve(null)
        },
        async showStatus () {
            let status = this.appInfo.status
            // if (status !== 'draft') {
            //     status = this.appInfo.lastStatus &&
            //           (this.appInfo.lastStatus === 'unpublished' ||
            //               this.appInfo.lastStatus === 'removed')
            //         ? this.appInfo.lastStatus
            //         : this.appInfo.status
            // }

            const langCode = this.$root.$i18n.locale
            this.statusText = await this._transferStatusAsync(status, langCode)
        },
        getNameByLangCode () {
            const langCode = this.$root.$i18n.locale
            let pkgName = `Unnamed(${langCode})`
            let can = _.find(this.appInfo.candidate, o => o.langCode === langCode)
            if (can) {
                pkgName = can.title
            }
            return pkgName
        },
        testValid (vArray) {
            return !vArray.some(o => o === false || o == null)
        },
        errMsgs () {
            return this.$store.state.botAppErrMessages || []
        },
        isAppInfoChanged () {
            // this.$store.state.originalAppInfo
            // this.appInfo with all sub data.
            let curAppInfo = { ...this.getAllData() }
            let orgAppInfo = this.$store.state.originalAppInfo

            delete curAppInfo.contentExtra
            delete curAppInfo.apkFile
            delete curAppInfo.previewApkFile
            delete curAppInfo.status

            delete orgAppInfo.contentExtra
            delete orgAppInfo.apkFile
            delete orgAppInfo.previewApkFile
            delete orgAppInfo.status

            return !_.isEqual(curAppInfo, orgAppInfo)
        }
    },
    computed: {
    // isUpdate () {
    //     return !!this.appInfo.appId
    // },
    // isCreate () {
    //     return !this.appInfo.appId
    // },
    // appLock () {
    //     return this.appLockStatus.indexOf(this.appInfo.status) > -1
    // },
    // dataChanged () {
    //     let inDev = false
    //     return inDev || this.appInfo.status === 'draft'
    // },
    // enableReview () {
    //     return true
    //     // return !this.tabsValid.some(o => o === false || o == null)
    // },
        packageVersion: {
            get () {
                let ver = '1.0'
                if (this.appInfo.apkFile) ver = this.appInfo.apkFile.versionName
                return ver
            }
        },
        projectName () {
            return this.appInfo.projectName

            // var prjName = 'unnamed project'
            // if (this.appInfo.candidate && this.appInfo.candidate[0]) {
            //     prjName = this.getNameByLangCode()
            // }
            // return this.$route.query.title || prjName
        },
        onReview () {
            return this.appInfo.status !== 'draft'
        },
        myProjectsSearchId () {
            console.log(this.$store.state.myProjectsSearchId)
            let { key } = this.$store.state.myProjectsSearchId
            if (key === 'MyProjectsEdit') {
                this.getAppInfo()
                // localStorage.setItem('appId', val)
            }
            return this.$store.state.myProjectsSearchId
        }
    }
}
</script>

<!--<style src="./botApp.scss" scoped></style>-->

<style lang="scss">
.botAppTabs {
  h1,
  h3 {
    display: inline-block;
  }
  .op-buttons {
    margin: 0.3rem;
    text-align: right;
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    color: black; //#00b5e2
    .icon {
      color: #ddd;
    }
  }
  .el-tabs--border-card
    > .el-tabs__header
    .el-tabs__item:not(.is-disabled):hover {
    color: black;
    .icon {
      color: #ddd;
    }
  }

  .valid {
    color: #00b5e2;
    .icon {
      color: #00b5e2 !important;
    }
  }
  .invalid {
    color: #f56c6c;
    .icon {
      color: #f56c6c !important;
    }
  }
  .el-alert {
    display: -webkit-box;
    -webkit-box-align: unset;
  }
}
</style>

<style>
.vue-tooltip.tooltip-custom {
  background-color: white;
}

.vue-tooltip.tooltip-custom .tooltip-arrow {
  border-color: black;
}
.vue-tooltip.tooltip-custom .tooltip-content {
  color: black;
}
</style>
